
import React from "react";

interface TableLoadingOverlayProps {
  isLoading: boolean;
  message?: string;
  showProgress?: boolean;
  progress?: {
    current: number;
    total: number;
    url?: string;
  } | null;
}

export function TableLoadingOverlay({
  isLoading,
  message = "Loading...",
  showProgress = false,
  progress = null
}: TableLoadingOverlayProps) {
  if (!isLoading) {
    return null;
  }

  const progressPercentage = progress 
    ? Math.round((progress.current / progress.total) * 100) 
    : null;

  return (
    <div className="absolute inset-0 bg-background/80 backdrop-blur-[1px] z-50 flex flex-col items-center justify-center">
      <div className="flex flex-col items-center space-y-4 p-8 bg-card rounded-lg shadow-lg animate-fade-in text-center">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-primary border-t-transparent"></div>
        <p className="font-medium">{message}</p>
        
        {showProgress && progress && (
          <div className="w-full space-y-2">
            <div className="h-2 w-full bg-secondary overflow-hidden rounded-full">
              <div 
                className="h-full bg-primary transition-all duration-500" 
                style={{ width: `${progressPercentage}%` }}
              ></div>
            </div>
            <p className="text-sm text-muted-foreground">
              {progress.current} of {progress.total} ({progressPercentage}%)
            </p>
            {progress.url && (
              <p className="text-xs text-muted-foreground truncate max-w-[300px]">
                Processing: {progress.url}
              </p>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
